export default __webpack_public_path__ + "static/media/SpeedEquationsImg.bc45ab87.jpg";